// open the login
$('body').on('click', '.login-trigger', function() {
	openModal('.modal.login');
    // $('.overlay, .modal.login').addClass('visible');
    return false;
});

// close the login
$('body').on('click', '.close-login', function() {
    $('.modal.login').removeClass('visible');
    return false;
});


// open the register
$('body').on('click', '.register-trigger', function() {
    $('.overlay, .modal.register').addClass('visible');
    
    return false;
});

// close the register
$('body').on('click', '.close-register', function() {
    $('.modal.register').removeClass('visible');
    return false;
});

// open the forgot
$('body').on('click', '.forgot-trigger', function() {
    $('.overlay, .modal.forgot').addClass('visible');
    
    return false;
});

$('body').on('click', '.close-forgot', function() {
    $('.modal.forgot').removeClass('visible');
    return false;
});




// registering
$('body').on('submit', '.register form', function() {
	var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
	
	var error = false;

	$('.register .required').each(function() {
		if($(this).val() === '') {
			error = true;
		}
	});

	if(error) {
		showNotice('error', 'Registration Error', 'Please fill out all required fields', 'Try Again');
		return false;
	}
	
	showNotice('processing', 'Processing', null, null);
	$.ajax({
		type : 'POST',
		url : $this.attr('action'),
		data : fields,
		dataType : 'json',
		success : function(data) {
			// unloading();

			if(!data.success) {
				showNotice('error', 'Registration Error', data.message, 'Try Again');
				return false;
			}

			closeModal();
			showNotice('success', 'Registration Success', 'Email activation required, please check the link sent to your email address', 'Close');
		},
		error : function(request) {
			console.log(request.responseText);
		}
	});

	return false;
});

// loggin in
$('body').on('submit', '.login form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
	
	var error = false;

	$('.login .required').each(function() {
		if($(this).val() === '') {
			error = true;
		}
	});

	if(error) {
		showNotice('error', 'Login Error', 'Please fill out all required fields', 'Try Again');
	} else {
		showNotice('processing', 'Processing', null, null);
		$.ajax({
			type : 'POST',
			url : $this.attr('action'),
			data : fields,
			dataType : 'json',
			success : function(data) {
				// unloading();
				if (!data.success) {
					showNotice('error', 'Login Error', data.message, 'Try Again');
					return false;
				}

				closeModal();
				window.location.href = 'dashboard';
			},
			error : function(request) {
				console.log(request.responseText);
			}
		});
	}

	return false;
});

// forgot password
$('body').on('submit', '.forgot form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
	
	var error = false;

	$('.forgot .required').each(function() {
		if($(this).val() === '') {
			error = true;
		}
	});

	if(error) {
		showNotice('error', 'Recover Password Error', 'Please fill out all required fields', 'Try Again');
		return false;
	}

	showNotice('processing', 'Processing', null, null);
	$.ajax({
		type : 'POST',
		url : $this.attr('action'),
		data : fields,
		dataType : 'json',
		success : function(data) {
			// unloading();
			if(!data.success) {
				showNotice('error', 'Recover Password Error', data.message, 'Try Again');
				return false;
			}

			closeModal();
			showNotice('success', 'Recover Password Success', data.message, 'Close');
		},
		error : function(request) {
			console.log(request.responseText);
		}
	});

	return false;
});


// reset password
$('body').on('submit', '.reset form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
	
	var error = false;

	$('.reset .required').each(function() {
		if($(this).val() === '') {
			error = true;
		}
	});

	if(error) {
		showNotice('error', 'Reset Password Error', 'Please fill out all required fields', 'Try Again');
		return false;
	}
	
	showNotice('processing', 'Processing', null, null);
	$.ajax({
		type : 'POST',
		url : $this.attr('action'),
		data : fields,
		dataType : 'json',
		success : function(data) {
			// unloading();
			if (!data.success) {
				showNotice('error', 'Reset Password Error', data.message, 'Try Again');
				return false;
			}

			closeModal();
			window.location.reload();
		},
		error : function(request) {
			console.log(request.responseText);
		}
	});

	return false;
});